import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_5 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;

  return (
    <>
      <g>
        <path
          fill={primary}
          d="M556.9,229.7c-0.3-0.7-0.7-1.4-1-2.2c-1.6-3.2-3.2-6.4-5.1-9.8c-0.1-0.1-0.1-0.2-0.2-0.3
			c-6.6-11.9-14.8-23.7-24.9-35c-27-33-70-72-122.1-72c-51.8,0-63.1,43.2-63.1,43.2c-9.1-14.2-21.3-14.4-28.2-13
			c-24.8,5-50.6,47.4-64.8,73.8c-3,5.1-5.6,10.2-8,15.3c-0.1,0.2-0.2,0.4-0.3,0.6c-5.1,9.8-8.4,19.1-10.4,27.9
			c-16.1,54.9-5.6,102.8-4.5,106.5c7.1,22.4,44.7,106.8,45.9,123.3c4.2,59.3-21.7,82.2-21.7,82.2c16.9,10.7,50,0.6,50,0.6
			c-5.9,21.4-40,34.4-40,34.4c32.6,34.1,76.7,6.9,76.7,6.9c4.8-5.1,6.1-11,6.1-16.3c-15.3-14.5-33.2-34-39.6-47.7
			c-10.7-23.1-18.5-75.8-22.9-104.7c-0.5-3.4-1-8.5-1.3-14.8c0.2,0.8,0.3,1.3,0.3,1.3c5.5-23.4,7-48.3,7.1-66c0-2.1,0.5-4.8,1.2-7.6
			c10.4-12,29.4-36.6,46.2-72.5c23.2,32.8,56.6,64.3,103,74.3c3.5,0.8,7.1,1.4,10.8,1.9c0.1,0,0.3,0.1,0.4,0.1
			c3.8,0.5,7.6,0.9,11.6,1.1c-3.5-3.1-26-22.1-29.2-25.5c-17.1-18-25.8-24.5-38.4-49.7c12.7,11,23.7,24.9,37.1,34.4
			c39.3,27.9,82.8,35.3,82.6,34.7c0.9,3.3,1.5,6.4,1.6,8.8c0.1,17.7,1.6,42.5,7.1,65.9c-0.3,5.7-0.8,10.4-1.2,13.6
			c-4.4,28.9-12.2,81.6-22.9,104.7c-6.3,13.7-24.3,33.2-39.6,47.7c0,5.3,1.3,11.3,6.1,16.3c0,0,44.1,27.2,76.7-6.9
			c0,0-34.2-13-40-34.4c0,0,33.1,10.1,50-0.6c0,0-26-23-21.7-82.2c1-14.1,28.6-77.6,41-109.8h-0.1c-0.2-0.4-3.2-5.5-5-5
			c-1.4,0.4-1.9,4.2-1.1,9.4c2.1-1.5,4.2-2.9,6.2-4.4c2.5-5.9,4-10.7,4.9-13.5C572.1,364.6,588.9,305.8,556.9,229.7z M541.6,381.1
			L541.6,381.1L541.6,381.1z"
        />
        <path
          fill={secondary}
          d="M556.9,229.7c-0.3-0.7-0.7-1.4-1-2.2c-1.6-3.2-3.2-6.4-5.1-9.8c-0.1-0.1-0.1-0.2-0.2-0.3
			c-6.6-11.9-14.8-23.7-24.9-35c-27-33-70-72-122.1-72c-51.8,0-63.1,43.2-63.1,43.2c-9.1-14.2-21.3-14.4-28.2-13
			c-24.8,5-50.6,47.4-64.8,73.8c-2.5,4.2-4.7,8.5-6.7,12.7c12.4-3.2,34.8-15.3,34.4-14.6c-14.1,26-10.6,54.9-8.8,72.2
			c9.9-16.2,29.1-51.1,41.8-64c15,42.2,51.9,83.2,90.1,96.3c-21.3-32.3-29.9-70.2-29.5-93.2c10.7,20.2,28.5,43.8,48.8,60.6
			c14.9,12.3,31.8,21.9,43.2,27.7c-0.7-2-25.7-39.9-27.1-69.6c0.6,1.2,52.9,78.3,98.5,86.2c0.2,0,0.4,0.1,0.6,0.2
			c-28.1-23.9-50.6-80.4-64-119.3c29.9,39.8,71.7,40.3,94.3,111.8c1.9-7.4,10.3-24.7,11.3-32.3C571.7,270.5,566.5,250.2,556.9,229.7
			z"
        />
        <path
          fill={primary}
          d="M292.7,207.6c0.2,0.3,0.5-0.5,0.2-0.7c-0.3-0.2-0.7,0.1-1,0.4c-1.5,1.5-2.9,3-4.4,4.5
			c1.1-13.5,7.2-26.1,16.1-34c8.9-7.9,20.3-11,31.1-8.9C318.3,176.8,303.5,190.3,292.7,207.6z"
        />
        <path
          fill={primary}
          d="M447.8,161.7c7,6.9,16.3,8.9,25.2,10.7c-8.7,3.7-18.4,6.5-26.8,2c-9.3-4.9-14.9-17.5-24.2-22
			c-4.1-2-8.5-2.2-12.9-2.5c-3.6-0.2-7.3-0.4-10.9-0.6c-3-1.1-6.2-1.4-9.3-0.9c0.3-0.9,1.5,0.5,0.8,0.9c0.8-1.1-1.2-2.8-1.7-1.5
			c8.1-3.6,16.3-6.9,24.9-7.5c8.6-0.6,17.5,1.8,24.2,8.4C441,152.7,443.9,157.9,447.8,161.7z"
        />
        <path
          fill={primary}
          d="M409,188.5c-2.9-5.1-5.9-10.5-10.2-13.5c-6.2-4.3-14-3.3-21-1.6c6.6,3.4,12.6,8.6,17.5,15.2
			c4.2,5.7,7.6,12.4,12,17.9c4.4,5.5,10.5,9.8,16.7,9C418.9,206.5,414,197.5,409,188.5z"
        />
        <path
          fill={primary}
          d="M347.6,180c-10.4,15.9-10.8,40.5-1,56.9C346.3,218,346.6,199,347.6,180z"
        />
      </g>
    </>
  );
};

export default Hair_5;
